import { createSlice } from '@reduxjs/toolkit';

export const userActivitySlice = createSlice({
    name: 'userActivity',
    initialState: {
        activity: null
    },
    reducers: {
        setActivity: (state, action) => {
            state.activity = action.payload;
        },
    }
})

export const { setActivity } = userActivitySlice.actions;
export default userActivitySlice.reducer;